module.exports = __webpack_public_path__ + "img/mi.b7d0a373.png";